import axios from 'axios'

import {HOST} from '../../config'

export const ActionConst = {
  SET_DATA_OBJECT: 'AUTH_SET_DATA_OBJECT',
  SET_TOKEN: 'AUTH_SET_TOKEN',
  SET_ERROR: 'AUTH_SET_ERROR',
  IS_FETCHING: 'AUTH_IS_FETCHING'
}

function _setAxiosAuthorization(token) {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Basic ${token}`
  } else {
    delete axios.defaults.headers.common['Authorization']
  }
}

function _setDataObject (dataObject) {
  return {
    type: ActionConst.SET_DATA_OBJECT,
    dataObject
  }
}

function _isFetching (isFetching) {
  return {
    type: ActionConst.IS_FETCHING,
    isFetching
  }
}

function _setToken (token) {
  if (token) {
    localStorage.setItem('token', token)
  } else {
    localStorage.removeItem('token')
  }

  _setAxiosAuthorization(token)

  return {
    type: ActionConst.SET_TOKEN,
    token
  }
}

function _setError (error) {
  return {
    type: ActionConst.SET_ERROR,
    error
  }
}

export function setPropDataObject (data) {
  return (dispatch, getState) => {
    let {dataObject} = getState().auth
    dispatch(_setDataObject({...dataObject, ...data}))
  }
}

export function load () {
  return (dispatch) => {
    //Busca o token do localStorage
    dispatch(_setToken(localStorage.getItem('token')))
  }
}

export function sair () {
  return (dispatch) => {
    dispatch(_setDataObject({}))
    dispatch(_setToken())
  }
}

export function logar () {
  return (dispatch, getState) => {
    let {dataObject} = getState().auth

    if (!dataObject.login || !dataObject.password) {
      let error = {code: 'Erro!', message: 'Usuário ou senha não foram informados.'}
      dispatch(_setError(error))
      return Promise.reject(error)
    }

    let url = `${HOST}/api/mobile/auth/signin`

    dispatch(_isFetching(true))
    return axios.post(url, dataObject).then((response) => {
      let {token} = response.data
      dispatch(_setToken(token))
      dispatch(_isFetching(false))
      return token
    }).catch((error) => {
      if (error.response) {
        error = error.response.data.error
      }
      dispatch(_isFetching(false))
      dispatch(_setError(error))
      return Promise.reject(error)
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/auth/index.js